export const SET_SIDEBAR_TRANSACTIONS_COUNT = 'SET_SIDEBAR_TRANSACTIONS_COUNT';
export const SET_REIMBURSABLE_EXPENSES_COUNT = 'SET_REIMBURSABLE_EXPENSES_COUNT';
export const SET_CARD_REQUESTS_COUNT = 'SET_CARD_REQUESTS_COUNT';
export const SET_READY_TO_PAY_BILLS_COUNT = 'SET_READY_TO_PAY_BILLS_COUNT';
export const SET_SIDEBAR_PERSONAL_TRANSACTIONS_COUNT = 'SET_SIDEBAR_PERSONAL_TRANSACTIONS_COUNT';
export const SET_PERSONAL_REIMBURSABLE_EXPENSES_COUNT = 'SET_PERSONAL_REIMBURSABLE_EXPENSES_COUNT';
export const SET_RECEIPTS_COUNT = 'SET_RECEIPTS_COUNT';
export const SET_RECURRING_SPEND_SUGGESTIONS_COUNT = 'SET_RECURRING_SPEND_SUGGESTIONS_COUNT';
export const SET_ACCOUNTING_PAGE_COUNT = 'SET_ACCOUNTING_PAGE_COUNT';
export class SetSidebarTransactionsCount {
    constructor(count) {
        this.count = count;
        this.type = SET_SIDEBAR_TRANSACTIONS_COUNT;
        this.payload = count;
    }
}
export class SetCardRequestsCount {
    constructor(count) {
        this.count = count;
        this.type = SET_CARD_REQUESTS_COUNT;
        this.payload = count;
    }
}
export class SetReimbursableExpensesCount {
    constructor(count) {
        this.count = count;
        this.type = SET_REIMBURSABLE_EXPENSES_COUNT;
        this.payload = count;
    }
}
export class SetPersonalReimbursableExpensesCount {
    constructor(count) {
        this.count = count;
        this.type = SET_PERSONAL_REIMBURSABLE_EXPENSES_COUNT;
        this.payload = count;
    }
}
export class SetSidebarPersonalTransactionsCount {
    constructor(count) {
        this.count = count;
        this.type = SET_SIDEBAR_PERSONAL_TRANSACTIONS_COUNT;
        this.payload = count;
    }
}
export class SetReceiptsCount {
    constructor(count) {
        this.count = count;
        this.type = SET_RECEIPTS_COUNT;
        this.payload = count;
    }
}
export class SetReadytoPayBillsCount {
    constructor(count) {
        this.count = count;
        this.type = SET_READY_TO_PAY_BILLS_COUNT;
        this.payload = count;
    }
}
export class SetAccountingPageCount {
    constructor(count) {
        this.count = count;
        this.type = SET_ACCOUNTING_PAGE_COUNT;
        this.payload = count;
    }
}
export class SetRecurringSpendSuggestionsCount {
    constructor(count) {
        this.count = count;
        this.type = SET_RECURRING_SPEND_SUGGESTIONS_COUNT;
        this.payload = count;
    }
}
